import { render, staticRenderFns } from "./IrrigationDetail.vue?vue&type=template&id=781193c6&scoped=true"
import script from "./IrrigationDetail.vue?vue&type=script&lang=js"
export * from "./IrrigationDetail.vue?vue&type=script&lang=js"
import style0 from "./IrrigationDetail.vue?vue&type=style&index=0&id=781193c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781193c6",
  null
  
)

export default component.exports